// extracted by mini-css-extract-plugin
export default {"file_view":"AttachmentsViewer_file_view__amGg0"};